export const darkCustomStyles = {
  option: (base, state) => ({
    ...base,
    background: state.isFocused ? "whitesmoke" : "#212428",
    borderRadius: state.isFocused ? "0" : 0,
    cursor: "pointer",
    color: state.isFocused ? "#212428" : "whitesmoke",
    "&:hover": {
      color: state.isFocused ? "#212428" : "whitesmoke",
    },
  }),
  menu: (base) => ({
    ...base,
    color: "#fff",

    borderRadius: 0,
    marginTop: 0,
  }),
  menuList: (base) => ({
    ...base,
    color: "#fff",

    padding: 0,
  }),
  control: (base, state) => {
    const transitions = state.isFocused
      ? {
          background: "rgba(255, 52, 63, 0.2)",
          border: 0,
          outline: 0,
          boxShadow: "inset 0 1px 1px #ff343f, 0 0 8px #ff343f",
          transition: "background 1s",
          transitionTimingFunction: " linear",
        }
      : {};
    return {
      ...base,
      background: "#212428",
      borderRadius: "6px",
      height: "auto",
      boxShadow: "none",
      border: "solid 1px rgba(255, 255, 255, 0.1)",
      ...transitions,
    };
  },
  input: (base, state) => ({
    ...base,
    color: "#fff !important",
  }),
  singleValue: (base, state) => ({
    color: "#fff !important",
  }),
};

export const lightCustomStyles = {
  option: (base, state) => ({
    ...base,
    background: state.isFocused ? "#212428" : "#fff",
    borderRadius: state.isFocused ? "0" : 0,
    cursor: "pointer",
    color: state.isFocused ? "#fff" : "#212428",
    "&:hover": {
      color: state.isFocused ? "#fff" : "#212428",
    },
  }),
  menu: (base) => ({
    ...base,
    color: "#000",

    borderRadius: 0,
    marginTop: 0,
  }),
  menuList: (base) => ({
    ...base,
    color: "#000",

    padding: 0,
  }),
  control: (base, state) => {
    const transitions = state.isFocused
      ? {
          // background: "rgba(255, 52, 63, 0.2)",
          border: 0,
          outline: 0,
          boxShadow: "inset 0 1px 1px #8364e2, 0 0 8px #8364e2",
          transition: "background 1s",
          transitionTimingFunction: " linear",
        }
      : {};
    return {
      ...base,
      background: "#fff",
      borderRadius: "6px",
      height: "auto",
      boxShadow: "none",
      border: "solid 1px #000",
      ...transitions,
    };
  },
  input: (base, state) => ({
    ...base,
    color: "#000 !important",
  }),
  singleValue: (base, state) => ({
    color: "#000 !important",
  }),
};
